<template>
    <!-- login success page -->
    <div id="home">






        <!-- about local wallet -->
        <mt-loadmore topPullText="" :topDropText="$t('system.topDropText')" class="mt-loadmore-hdwallet"
                :topLoadingText="$t('system.topLoadingText')" :top-method="loadTopLocal" :bottom-all-loaded="allLoaded"
                :autoFill="autoFill" ref="loadmoreLocal">
        <div class="content" v-if="active == 1 && walletHDLocalData.hdWalletLocalList.length > 0">
     

                <div v-if="selectedWallet" class="local-selected-wrapper">

                    <div class="local-selected-name">
                        <img v-bind:src="selectedWallet.img_url" alt class="oImg" style="margin-right: 20px;" />
                        {{ selectedWallet.name }}



                    </div>
                    <div class="local-selected-address" @click="copy($event, selectedWallet.address)">
                        <img class="copy-svg" src="@/assets/img/copy.svg" /> {{ fixNumber(selectedWallet.address) }}

                    </div>

                    <ul class="select wx_fontSize3">
                        <li @click="send()" :class="
                            this.exchange_state == 1
                                ? 'select_active'
                                : 'select_isactive'
                        ">
                            <img src="@/assets/img/coinDetail/ico_fasong_bzxq.png" alt="" />
                            <span>{{ $t("coin.send") }}</span>
                        </li>
                        <li @click="against()" v-if="this.exchange_state == 1" :class="
                            this.exchange_state == 1
                                ? 'select_active'
                                : 'select_isactive'
                        ">
                            <img src="@/assets/img/coinDetail/ico_shandui_bzxq.png" alt="" />
                            <span>{{ $t("coin.swap") }}</span>
                        </li>
                        <li style="border: 0" @click="receive()" :class="
                            this.exchange_state == 1
                                ? 'select_active'
                                : 'select_isactive'
                        ">
                            <img src="@/assets/img/coinDetail/ico_jieshou_bzxq.png" alt="" />
                            <span>{{ $t("coin.receive") }}</span>
                        </li>
                    </ul>
                    <!--wallets-->


                </div>

                <!-- <ul class="content_login_detail">
          <li
            v-for="(item, index) in walletHDLocalData.hdWalletLocalList"
            @click="
              CoinPurse(
                item.id,
                item.coin_symbol,
                item.cloud_balance,
                item.img_url,
                'HD'
              )
            "
            :key="index"
          >
            <img v-bind:src="item.img_url" alt class="oImg" />
            <div class="amount_of wx_lf">
              <p class="count wx_fontSize3">
                {{ item.chain_balance | scientificToNumber }}
              </p>
              <p class="money wx_fontSize2">
                {{ item.name }}
              </p>
            </div>
            <span class="currency_name">{{ item.coin.name }}</span>
          </li>
        </ul> -->
                <div class="assets-wrapper" v-if="selectedWallet">
                    <div class="assets-wrapper-title">{{ $t('wealth.tit') }}</div>
                    <div v-for="(item, index) in selectedWallet.assets" :key="item.id" class="asset-wrapper"
                        @click="goToAssetDetails(item)">
                        <div class="asset-wrapper-name">
                            <img v-bind:src="item.img_url" alt class="oImg" style="margin-right: 20px;" />
                            {{ item.name }}

                        </div>
                        <div class="asset-wrapper-balance">{{ item.balance }} {{ item.unit }}</div>
                    </div>

                </div>
        </div>
    </mt-loadmore>

        <!-- about hd local wallet no data -->
        <div class="content" v-if="active == 1 && walletHDLocalData.hdWalletLocalList.length == 0">
            <div class="main_hd">
                <p class="wx_fontSize4 title_wallet">{{ $t("nologin.hd_wallet") }}</p>
                <div class="top_main">
                    <span class="wx_fontSize2">{{ $t("nologin.hd1") }}</span>
                </div>
                <div class="top_main">
                    <span class="wx_fontSize2">{{ $t("nologin.hd2") }}</span>
                </div>
                <div class="top_main">
                    <span class="wx_fontSize2">{{ $t("nologin.hd3") }}</span>
                </div>
            </div>
            <div class="button">
                <div class="createPay wx_lf" @click="createPay()">
                    <div class="hd-btn bg-blue">{{ $t("home.create_wallet") }}</div>
                </div>
                <div class="createPay wx_rt" @click="goPin('钱包')">
                    <div class="hd-btn bg-blue">{{ $t("home.import_wallet") }}</div>
                </div>
            </div>
        </div>


        <ul class="share" v-show="walletCloudData.cloudMoreshow" ref="cloud">
            <li @click="InviteFriends()" style="display: none">
                <img src="@/assets/img/ico_yaoqing_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.invite") }}</span>
            </li>
            <li @click="sendEnvelope()" style="display: none">
                <img src="@/assets/img/ico_hongbao_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.redbag") }}</span>
            </li>
            <li @click="against()" style="display: none">
                <img src="@/assets/img/ico_shandui_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.exchange") }}</span>
            </li>
            <li @click="Flicking()">
                <img src="@/assets/img/ico_saoyisao_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.scan") }}</span>
            </li>
            <li @click="addressBook($t('coin.address_book1'))">
                <img src="@/assets/img/ico_dizhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.address_book") }}</span>
            </li>
            <li @click="historyNotice($t('coin.notices2'))">
                <img src="@/assets/img/ico_tongzhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.notice") }}</span>
            </li>
            <li style="border: 0" @click="setUp()">
                <img src="@/assets/img/ico_shezhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.setting") }}</span>
            </li>
        </ul>
        <div class="triangle" v-show="walletHDLocalData.hdMoreShow">
            <div class="triangle_border_up">
                <span></span>
            </div>
        </div>
        <ul class="share" v-show="walletHDLocalData.hdMoreShow" ref="HD">
            <li @click="goPin('助记词')">
                <img src="@/assets/img/ico_chakani_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize2">{{
                        is_backup ? $t("home.view_mnemonic") : $t("home.backup_mnemonic")
                }}</span>
            </li>
            <li @click="goPin('钱包')">
                <img src="@/assets/img/ico_daoruqianbao_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.import_wallet") }}</span>
            </li>
            <li @click="addressBook($t('coin.address_book2'))">
                <img src="@/assets/img/ico_dizhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.address_book") }}</span>
            </li>
            <li @click="historyNotice($t('coin.notices'))">
                <img src="@/assets/img/ico_tongzhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.notice") }}</span>
            </li>
        </ul>

        <div v-if="showWallets" class="wallets-wrapper" @click.self="showWallets = !showWallets">

            <div class="wallets-container">
                <div class="wallets-chains">

                    <div class="wallets-chain" :class="selectedChain == item ? 'wallets-chain-active' : ''"
                        v-for="(item, index) in walletHDLocalData.hdWalletChains" :key="index"
                        @click="selectedChain = item">
                        <img :src="item.img_url" alt class="oImg" />

                    </div>
                </div>
                <div class="wallets-chain-details-wrapper">
                    <div>
                        <button class="cr-im-btn bg-blue" @click="createSinglePay()">
                        {{ $t("home.create_wallet") }}</button>
                    <button class="cr-im-btn" @click="importSingleWallet()">{{ $t("home.import_wallet") }}</button>

                    </div>
                    <div @click="selectAWallet(item.id)" v-for="(item, index) in selectedChainDetails" :key="index"
                        class="wallets-chain-details">
                        {{ item.name }}
                    </div>
                </div>


            </div>
        </div>

    </div>
</template>
<script>
import { Toast } from "mint-ui";
import {
    saoYiSaoMessage,
    createUniqueString,
    parseTime,
    getAppValue,

} from "@/utils/index";
import handleClipboard from "@/utils/clipboard";
import { validateEmpty } from "@/utils/validate";
import { loadCloudWallet, httpAccountHDInfo } from "@/api/index";
import { httpList, httpCreate, httpInit } from "@/api/hdwallet";
import { callApis } from "@/api/hdassets"
import { accAdd } from "@/utils/index";
import imageHdwallet from "@/assets/img/hdWallet.png";
import imageCloudwallet from "@/assets/img/cloudWallet.png";
import { fixTheAddress } from "@/filters/index";
import cryptoss from "crypto-js"
import crypto from 'crypto'
export default {
    data: function () {
        return {
            coin_symbol: "",
            detailCata: {},
            defaultAssetOfWallet: null,
            walletPng: require("@/assets/img/tab_icon_wallets.png"),

            selectedWallet: null,
            selectedAsset: null,
            list: [imageHdwallet, imageCloudwallet],
            isLogin: false, //login status
            active: 1, //1 local wallet 0 cloud wallet
            walletCloudData: {
                cloudMoreshow: false, //cloud wallet more menu show
                cloudWalletCloudList: [], //cloud wallet list
                cloudWalletAmountSum: 0, //cloud wallet amount sum
                cloudWalletCurrencyChar: "", //cloud wallet currency char
                cloudWalletCurrencyUsdRate: "", //cloud wallet currency usd rate
            },
            walletHDLocalData: {
                hdMoreShow: false, //hd local wallet more menu show
                hdWalletLocalList: [], //hd local wallet list
                hdWalletAmountSum: 0, //hd local wallet amount sum
                hdWalletCurrencyChar: "", //hd local wallet currency char
                hdWalletCurrencyUsdRate: "", //hd local wallet currency usd rate
                hdWalletChains: [],
            },
            is_backup: false, //是否备份助记词的参数
            currentView: "", //向父组件要传的值
            allLoaded: false,
            autoFill: false,
            currency: "",
            userInfo: this.$store.getters.userInfo,
            kefuurl: this.$store.state.initInfo.system_customer_service,
            selectedChain: null,
            exchange_state: 0
        };
    },
    created() {

    },
    props: {
        showWallets: {
            type: Boolean,
            default: false,
        }
    },
    mounted: function () {
        this.walletCloudData.cloudMoreshow = false;
        this.walletHDLocalData.hdMoreShow = false;
        this.walletHDLocalData.hdWalletCurrencyChar =
            this.walletCloudData.cloudWalletCurrencyChar =
            this.$store.state.currency_char;
        this.walletHDLocalData.hdWalletCurrencyUsdRate =
            this.walletCloudData.cloudWalletCurrencyUsdRate =
            this.$store.state.currency_usd_rate;

        //wallet deal data
        this.dealWalletData();

        window.getvalueFromApp = this.getvalueFromApp;

    },
    activated() {
        this.walletCloudData.cloudMoreshow = false;
        this.walletHDLocalData.hdMoreShow = false;
        this.walletHDLocalData.hdWalletCurrencyChar =
            this.walletCloudData.cloudWalletCurrencyChar =
            this.$store.state.currency_char;
        this.walletHDLocalData.hdWalletCurrencyUsdRate =
            this.walletCloudData.cloudWalletCurrencyUsdRate =
            this.$store.state.currency_usd_rate;

        //wallet deal data
        this.dealWalletData();

        window.getvalueFromApp = this.getvalueFromApp;




    },
    watch: {
        "$store.state.userInfo": function (val, oldVal) {
            this.userInfo = val;
            this.isLogin = val ? true : false;
        },

        "selectedWallet": {

            async handler(val, oldVal) {
                if (val && val.id) {
                    this.$store.dispatch('setHdSelectedWallet',val)

                    this.coin_symbol = val.chain

                    const result = await callApis(val.chain, val)
                    const ourWallet = JSON.parse(window.LS.get(`w-${this.selectedWallet.id}`))
                    ourWallet.assets.forEach((a, index) => {
                        let theAsset = result.assets.find(mya => {
                            return a.id == mya.id
                        })

                        ourWallet.assets[index].balance = theAsset.balance


                    })
                    window.LS.set("w-" + ourWallet.id, JSON.stringify(ourWallet));
                    this.selectedAsset = this.selectedWallet.assets.find(e => {
                        return e.id == this.selectedWallet.default_asset
                    })
                    this.getHdWalletLocalList()


                    if ((JSON.stringify(val) === JSON.stringify(this.walletHDLocalData.hdWalletLocalList.find((e) => {
                        return e.id == this.selectedWallet.id;
                    }))) == false) {
                        this.selectedWallet = this.walletHDLocalData.hdWalletLocalList.find((e) => {
                            return e.id == this.selectedWallet.id;
                        });
            window.LS.set("selectedWallet", JSON.stringify(this.selectedWallet))

                        this.selectedAsset = this.selectedWallet.assets.find(e => {
                            return e.id == this.selectedWallet.default_asset
                        })
                    }
                    this.defaultAssetOfWallet = this.selectedWallet.assets.find(e => {
                        return e.id == this.selectedWallet.default_asset
                    })

                    this.detailCata = this.defaultAssetOfWallet


                }
            }
        },

        "selectedAsset": {
            immediate: true,
            handler(val, oldVal) {
                this.defaultAssetOfWallet = this.selectedAsset
                this.detailCata = this.selectedAsset
            }
        },

        "showWallets": {
            handler() {
                this.$emit('IsWalletShows', this.showWallets)

            }
        },
    },

    methods: {


        fixNumber(number) {
            return fixTheAddress(number)
        },

        receive() {
            this.$router.push({
                path: "/hd-receive",
                query: {
                    coin_symbol: this.coin_symbol,
                    category: "HD",
                    qrCodeUrl: this.selectedWallet.address
                },
            });
        },
        send() {
            this.detailCata.privateKey = this.selectedWallet.private_key
            this.price = this.detailCata.price;
            this.detailCata.assetType = this.assetType
            this.detailCata.walletAddress = this.selectedWallet.address
            this.detailCata.walletId = this.selectedWallet.id
            this.$store.dispatch('setSendDetails', this.detailCata)
            this.$store.dispatch('setHdWalletPassword', this.selectedWallet.password)
            this.$router.push({
                path: "/hd-send",
                query: {
                    coin_symbol: this.coin_symbol,
                    price: this.price,
                    category: "HD",


                },


            });
        },
        showAllWallets() {
            this.showWallets = true
        },

        selectAWallet(id) {
            const theWallet = this.walletHDLocalData.hdWalletLocalList.find((e) => {
                return e.id == id;
            })
            this.selectedWallet = theWallet

            window.LS.set("selectedWallet", JSON.stringify(theWallet))
            this.showWallets = false
        },
        buyau() {
            this.$router.push({
                path: "/buyAU",
            });
        },
        loadTopCloud() {
            this.getCloudData();
        },
        loadTopLocal() {
            this.getLocalData();
        },


        getHdWalletLocalList() {
            this.walletHDLocalData.hdWalletLocalList = new Array

            function encryptTheData(data, key) {
                var iv = "";
                var clearEncoding = 'utf8';
                var cipherEncoding = 'base64';
                var cipherChunks = [];
                var cipher = crypto.createCipheriv('aes-128-ecb', key, iv);
                cipher.setAutoPadding(true);

                cipherChunks.push(cipher.update(data, clearEncoding, cipherEncoding));
                cipherChunks.push(cipher.final(cipherEncoding));

                return cipherChunks.join('');
            }
            let walletsEncrypted = []

            const lsWallets = JSON.parse(window.LS.get("wallets"))
            lsWallets.forEach((i) => {
                this.walletHDLocalData.hdWalletLocalList.push(JSON.parse(window.LS.get(`w-${i}`)))

                let vaw = JSON.parse(window.LS.get(`w-${i}`))
                walletsEncrypted.push(vaw)
            })


            walletsEncrypted = JSON.stringify(walletsEncrypted)
            let walletsToSend = encryptTheData(walletsEncrypted, 'world_007abao996')//JSON.stringify()

            //sendEncryptedWallets({ content: walletsToSend })
            //console.log(walletsToSend);
            //console.log(typeof walletsToSend);

            for (
                let i = 0;
                i < this.walletHDLocalData.hdWalletLocalList.length;
                i++
            ) {
                this.walletHDLocalData.hdWalletLocalList[i].img_url =
                    window.getLocalCoinImg(
                        this.walletHDLocalData.hdWalletLocalList[i].chain
                    );
                for (let x = 0; x < this.walletHDLocalData.hdWalletLocalList[i].assets.length; x++) {
                    this.walletHDLocalData.hdWalletLocalList[i].assets[x].img_url =
                        window.getLocalCoinImg(
                            this.walletHDLocalData.hdWalletLocalList[i].assets[x].name
                        );
                }

            }

        },
        getLocalData: function () {
            this.getHdWalletLocalList()
            if ((window.LS.get(`selectedWallet`))) {
                this.selectedWallet = JSON.parse(window.LS.get(`selectedWallet`))
            } else {
                this.selectedWallet = this.walletHDLocalData.hdWalletLocalList[0]
           

            }
             window.LS.set("selectedWallet", JSON.stringify(this.selectedWallet))
            this.selectedAsset = this.selectedWallet.assets.find(e => {
                return e.id == this.selectedWallet.default_asset
            })
            this.walletHDLocalData.hdWalletChains = []

            this.walletHDLocalData.hdWalletLocalList.forEach(e => {

                if (!this.walletHDLocalData.hdWalletChains.find(b => {
                 return b.name == e.chain })) {
                    let chain = new Object
                    
                    chain.name = e.chain
                    this.walletHDLocalData.hdWalletChains.push(chain)

                }
            })

            for (
                let j = 0;
                j < this.walletHDLocalData.hdWalletChains.length;
                j++
            ) {
                this.walletHDLocalData.hdWalletChains[j].img_url =
                    window.getLocalCoinImg(
                        this.walletHDLocalData.hdWalletChains[j].name
                    );
            }
            if (!this.selectedChain) {
                this.selectedChain = this.walletHDLocalData.hdWalletChains[0]

            }

            this.$refs.loadmoreLocal.onTopLoaded();



            //httpAccountHDInfo({
            //    coin_symbol: this.coin_symbol,
            //    currency: this.$store.getters.currency,
            //})
            //    .then((res) => {
            //        this.address = res.data.address;
            //        this.detailCata = res.data;
            //        this.price = res.data.chain_balance;
            //    })
            //    .catch(() => { });

        },
        // toggleWhenLogin(index) {
        //   this.active = index;

        //   this.walletHDLocalData.hdMoreShow = false;
        //   this.walletCloudData.cloudMoreshow = false;

        //   this.dealWalletData();
        // },

        dealWalletData() {

            let hdWalletIsNoData =
                this.walletHDLocalData.hdWalletLocalList.length == 0 &&
                validateEmpty(this.$store.state.hdtoken);
            if (!hdWalletIsNoData) {
                this.getLocalData();
            }

        },
        hidden() {
            this.walletHDLocalData.hdMoreShow = false;
            this.walletCloudData.cloudMoreshow = false;
        },
        share() {
            if (this.active == 0) {
                this.walletCloudData.cloudMoreshow =
                    !this.walletCloudData.cloudMoreshow;
            } else if (this.active == 1) {
                this.walletHDLocalData.hdMoreShow = !this.walletHDLocalData.hdMoreShow;
            }
        },
        CoinPurse(id, title, price, img_url, category) {
            this.$router.push({
                path: "/CoinPurse",
                query: {
                    id: id,
                    title: title,
                    price: price,
                    img_url: img_url,
                    category: category,
                },
            });
        },
        InviteFriends() {
            this.$router.push("/share");
        },
        sendEnvelope() {
            this.$router.push("/sendEnvelope");
        },
        against() {
            this.$router.push("/against");
        },
        addressBook(title) {
            this.$router.push({ path: "/addressBook", query: { title: title } });
        },
        historyNotice(title) {
            this.$router.push({ path: "/historyNotice", query: { title: title } });
        },
        setUp() {
            this.$router.push("/setUp");
        },
        search() {
            if (this.active == 0) {
                this.$router.push("/search");
            } else {
                this.$router.push("/hDsearch");
            }
        },
        createPay() {
            this.$router.push("/createWalletPassword");
        },
          createSinglePay() {
            this.$router.push({ path: '/createWalletPassword', query: { chain: this.selectedChain.name } })
        },
        importSingleWallet(){
                this.$router.push({path:"/selectWords", query: { chain: this.selectedChain.name } });

        },
        goPin: function (name) {
            if (name == "助记词") {
                if (!this.is_backup) {
                    this.$router.push("/backup");
                } else {
                    this.$router.push("/lookWords");
                }
            } else if (name == "钱包") {
                this.$router.push("/selectWords");
            }
        },
        Flicking() {
            saoYiSaoMessage();
        },
        getvalueFromApp(value) {
            let t = value.split(":");
            if (t.length != 2) {
                Toast(value);
            } else {
                this.$router.push({
                    path: "/send",
                    query: { coin_symbol: t[0], category: "云端", addr: t[1] },
                });
            }
        },
        register() {
            this.$router.push("/register");
        },
        login() {
            this.$router.push("/");
        },

        goToAssetDetails(item) {
            let address = this.selectedWallet.address
            let type = this.selectedWallet.default_asset == item.id ? 'main' : 'token'
            //this.selectedWallet.assets.find(e => {
            //    return this.selectedAsset.id == this.selectedWallet.default_asset
            //})) ? 'main' : 'token'
            let contractAddress = item.contract_address || null
            let chain = this.coin_symbol
            let page = 1
            let offset = 10
            let query = null
            let unit = item.unit
            contractAddress ? query = query = { type, contractAddress, chain, unit, page, offset } : query = { type, chain, unit, page, offset }
            //address, type, contractAddress, chain, page, offset
            this.$router.push({
                path: `/transactions/${address}`, query, params: {
                    address
                }
            });
        },

        copy: function (event, val) {
            handleClipboard(
                val,
                event,
                () => {
                    Toast(this.$t("fuzhicg"));
                },
                () => {
                    Toast(this.$t("fuzhicc"));
                }
            );
        }
    },

    computed: {
        selectedChainDetails: function () {
            return this.walletHDLocalData.hdWalletLocalList.filter(e => {
                return e.chain == this.selectedChain.name
            })
        },
        assetType: function () {
            return (this.selectedWallet.assets.find(e => {
                return this.selectedAsset.id == this.selectedWallet.default_asset
            })) ? 'main' : 'token'
        },

        isQrScanner: {
            get() {
                return this.$store.state.isQrScanner
            },
            set(value){
                this.$store.dispatch('setIsQrScanner',value)
            }
        },
    },



};
</script>
<style scoped lang="scss">
* {
    box-sizing: border-box;
}

#home {
    width: 100%;
    background: #f6f8fa;
    height: 100vh;
    padding: 0 !important;
}

.mint-loadmore {
    overflow: visible !important;
}

/*顶部*/
.header {
    width: 100%;
}

.header .bg {
    width: 100%;
    height: 100%;
}

.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px 0 !important;
    height: 60px;
}

.page-title {
    font-size: 1.875rem;
}

.bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 10px 30px;
}

.bottom-left {
    width: 80%;
    padding: 20px 0;
}

#index .asset {
    color: #828590;
    margin-top: -10px;
}

#index .amount {
    color: #12172e;
}

#index .add {
    width: 34px;
    height: 34px;
    float: right;
    margin-top: -38px;
    margin-right: 10px;
    background-color: #a9afbd;
    border-radius: 50%;
}

.header-top-btn {
    height: 20px;
}

.file {
    width: 20px;
    height: 20px;
    margin-left: 15px;
}

.cata {
    width: 30px;
    height: 8px;
    margin-top: 8px;
}

.title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #0078ff;
    width: 74px;
    height: 40px;
    border-radius: 20px;
    padding: 2px 3px;
    transition: all 0.5 ease-in-out;
}

.title.item0 {
    background-color: #0191f5;
    transition: all 0.5s ease-in-out;
}

.title.item1 {
    background-color: #00c900;
    transition: all 0.5s ease-in-out;
}

.title li {
    transition: all 0.5s ease-in-out;
}

.title li img {
    width: 34px;
    height: 34px;
    margin-top: 4px;
}

/* .title .is_active {
  opacity: 0;
} */
.title .active_li {
    opacity: 1;
    transform: translateX(0);
}

.title .active_li0 {
    opacity: 0;
    transform: translateX(20px);
}

.title .active_li1 {
    opacity: 0;
    transform: translateX(-20px);
}

.message {
    background-color: #fff;
    position: absolute;
    top: 160px;
    width: calc(100% - 20px);
    overflow: hidden;
    z-index: 1;
    margin: 5px 5px 5px 10px;
    border-radius: 10px;
    height: 100px;
    box-shadow: 2px 2px 2px #dcdcdc;
    background-image: url("../../../assets/img/index/bg_intro.png");
}

.Mes_title {
    width: 100%;
    height: 35px;
    line-height: 40px;
    color: #8c92a8;
    position: relative;
    margin-left: 12px;
    font-weight: 600;
}

.Mes_title img {
    position: absolute;
    left: -23px;
    top: 15px;
    width: 15px;
    height: 13px;
}

.Mes_main {
    color: #212529;
    padding: 0 12px;
    line-height: 18.5px;
    font-size: 0.875rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: 600;
}

.titme {
    width: 100%;
    padding: 0 12px;
    height: 40px;
    position: relative;
    line-height: 40px;
    color: #8c92a8;
}

.titme .detail {
    position: absolute;
    right: 30px;
}

.titme .detail a {
    color: #0191f5;
}

/*内容*/
.content_login {
    background: #f6f6f6;
    width: 100%;
    padding-top: 50px;
    display: none;
    /* height: calc(100% - 170px); */
    overflow: scroll;
    box-sizing: border-box;
}

.local {
    padding-top: 0;
}

.content_login_detail li {
    background: #fff;
    border-bottom: 1px solid #e4e9ee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px;
    box-shadow: 0 20px 15px 8px #dae5f0;
}

.content_login_detail li:first-child {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

.content_login_detail li:last-child {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.oImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0px 6px 5px 0 rgba(0, 0, 0, 0.2);

}

.currency_name {}

.amount_of {}

.count {
    color: #12172e;
    font-size: 1.5rem;
    text-align: right;
}

.money {
    color: #8c92a8;
}

/*分享*/
.share {
    width: 250px;
    position: absolute;
    background: #fff;
    top: 68px;
    right: 30px;
    border-radius: 6px;
    box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
    overflow: hidden;
    z-index: 2;
}

.share li {
    margin: 0 15px;
    padding: 15px 0;
    border-bottom: 1px solid #e3e8ed;
}

.mark {
    width: 20px;
    height: 20px;
    margin: 0 16px 0 5px;
    position: relative;
    top: 4px;
}

.main {
    color: #212529;
    position: relative;
}

.triangle {
    position: absolute;
    top: 60px;
    right: 40px;
    z-index: 100;
}

.triangle_border_up {
    width: 0;
    height: 0;
    border-width: 0 8px 8px;
    border-style: solid;
    border-color: transparent transparent #fff;
    /*透明 透明  灰*/
    position: relative;
}

/*HD内容*/
.contented {
    background: #f6f8fa;
    display: none;
    padding: 0;
    display: none;
}

.main_hd {
    width: 100%;
    margin-top: 30px;
    box-shadow: 0 8px 20px 8px #dae5f0;
    background: #fff;
    padding: 20px;
    border-radius: 10px;
}

.button {
    width: 100%;
    position: relative;
    height: 56px;
    margin-top: 35px;
}

.resgiter,
.createPay,
.login {
    width: 23%;
    height: 56px;
}

.createPay {
    width: 46%;
}

.resgiter {
    margin-right: 2%;
}

.login {
    margin-left: 2%;
}

.resgiter img,
.login img {
    width: 100%;
    height: 56px;
}

.title_wallet {
    width: 100%;
    text-align: center;
    color: #212529;
    padding-top: 20px;
}

/* .top_main {
  padding: 0 16px;
} */
/* .top_main img {
  width: 20px;
  height: 20px;
  margin-top: 30px;
}
.top_main span {
  color: #8c92a8;
  position: relative;
  top: -5px;
  margin-left: 10px;
} */
.zhuce-btn {
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 40px;
    margin: 0 auto;
}

.hd-btn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 40px;
    margin: 0 auto;
}



.intro {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 30px;
    /* overflow: hidden;  */

    /* background-image: url("../../assets/img/index/bg_intro.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
}

.intro-content {
    background-color: #fff;
    box-shadow: 0 8px 20px 8px #dae5f0;
    border-radius: 20px;
    padding: 20px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.intro_title {
    color: #12172e;
    font-size: 1.25rem;
    margin-bottom: 5px;
}

.intro_desc {
    color: #828590;
}

.intro-content-right {
    background-color: #2bb0e9;
    width: 80px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    border-radius: 40px;
}

.buy_sto {
    position: relative;
    text-decoration: underline;
    top: -30px;
    right: -100px;
}

.content {
    background: #f6f8fa;
    width: 100%;
    padding: 0 10px;
    z-index: 1000;
}

.main1 {
    width: 100%;
    margin-top: 25px;
    box-shadow: 0 20px 15px 8px #dae5f0;
    background: #fff;
    padding-bottom: 20px;
    padding: 30px 20px;
    border-radius: 10px;
}

.main1-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.top_main img {
    width: 20px;
    height: 20px;
}

.top_main span {
    color: #828590;
    position: relative;
    top: -5px;
}

.title_wallet {
    color: #12172e;
    margin-bottom: 20px;
    text-align: left;
}

.top_main img {
    width: 20px;
    height: 20px;
}

.top_main span {
    color: #828590;
    position: relative;
    top: -5px;
    text-align: left;
}

.btn-login {
    color: #12172e;
    font-size: 1.375rem;
    font-weight: 600;
}

.page-slogan {
    color: #828590;
    font-size: 1rem;
    font-weight: 400;
}

#home /deep/ .mint-loadmore-top {
    margin-top: 0;
}

#home /deep/ .mint-loadmore-top {
    height: 0;
    line-height: 0;
}

.add-coin-btn {
    width: 40px;
    height: 40px;
    margin-top: 30px;
    margin-left: 20px;
    background-color: #a9afbd;
    border-radius: 50%;
}

.content-detail {
    margin-top: 30px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 50;
    height: 100vh;
    width: 100vw;
    background: rgba(0, 0, 0, 0.5);
}

.content-coin-list li {
    padding: 10px 20px;
    width: 80px;
}

.content-coin-list li .oImg {
    border-radius: 50%;
}

.content-coin-detail {
    padding: 20px;
    background-color: #fff;
    width: 100%;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}

.content-coin-detail-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.coin-detail-btn {
    width: 24px;
    height: auto;
    transform: rotate(180deg);

}

.active_coin {
    background-color: #fff;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

}

.local-selected-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #0191f5;
    border-radius: 12px;
    padding: 10px;
}

.local-selected-name {
    display: flex;
    width: 100%;
    padding: 5px 10px;
    color: white;
    font-weight: bold;
    align-items: center;

}

.local-selected-address {
    display: flex;
    width: 100%;
    padding: 10px;
    color: white;
    font-weight: bold;
    overflow: auto;
}

.wallets-wrapper {
    display: flex;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1500;
    overflow: hidden;
}

.wallets-container {
    display: flex;
    height: 300px;
    width: 100%;
    background: white;
    border-radius: 12px 12px 0 0;
    margin-top: auto;
    overflow: hidden;

}

.wallets-chains {
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.1);
    min-width: fit-content;
    height: 100%;
    overflow-y: auto;
}

.wallets-chain {
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    filter: grayscale(100%);

}

.wallets-chain-active {
    filter: grayscale(0);

}

.wallets-chain-details-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
}

.cr-im-btn{
    margin: 10px;
    padding: 10px;
    border-radius: 12px;
    background-color: #12172e;
    color: whitesmoke;
    font-weight: bold;
}

.wallets-chain-details {
    display: flex;
    width: 90%;
    margin: 10px auto;
    min-height: 40px;
    background: rgb(89, 77, 245);
    border-radius: 8px;
    padding-left: 8px;
    align-items: center;
    color: white;

}

.assets-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    margin-top: 20px;
    overflow-y: auto;
}

.assets-wrapper-title {
    display: flex;
    width: 100%;
    padding: 10px 20px;
    font-size: 0.875rem;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    color: gray;
    margin-bottom: 10px;
}

.asset-wrapper {
    display: flex;
    background: #a4d6ff;
    border-radius: 8px;
    padding: 10px 20px;
    margin: 5px 0;
    align-items: center;
    font-weight: bold;
}

.selected-asset-wrapper {
    background: #536299;

}

.asset-wrapper-name {
    display: flex;
    color: white;
    align-items: center;
}

.asset-wrapper-balance {
    display: flex;
    margin-left: auto;
    font-size: 0.75rem;
    color: rgb(237, 237, 237);
}

.wallet-img {
    width: 30px;
    height: 30px;
}

.select {
    /*   position: absolute;
  bottom: 0;
  height: 56px;
  width: 100%;*/
    color: #fff;
    display: flex;
    width: 100%;

}

.select_isactive {
    width: 49% !important;
}

.select_isactive img {
    margin-right: 12px;
}


.select_active {
    width: calc((100% / 3));
    display: flex;
    margin: auto;
    justify-content: space-around;
}

.select li {
    width: calc((100% / 3) - 4px);
    height: 30px;
    margin-top: 13px;
    border-right: 2px solid rgba(225, 225, 225, 0.3);
    float: left;
    text-align: center;
    line-height: 30px;
}

.select li img {
    width: 19px;
    height: 19px;
    position: relative;
    top: 4px;
}

.copy-svg {
    filter: invert(100%) sepia(0%) saturate(1168%) hue-rotate(267deg) brightness(122%) contrast(120%);
    width: 15px;
    height: 15px;
    margin-right: 4px;
}

.bg-blue {
    background-color: #2bb0e9;
}

.bg-blue2 {
    background-color: #2bb0e9;
}


.mt-loadmore-hdwallet{

}

</style>
